import React, { useMemo } from 'react';
import { PrivateGuard } from 'src/commons/components/PrivateRoute';
import { Profile as ProfileType } from './types';
import { Page } from './Page';
import { createRouter } from '../router';

export const Profile = ({ profile }: { profile: ProfileType }) => {
  const { RouterProvider, Routes } = useMemo(() => createRouter(profile.menu), [profile]);

  const ProfileComp = profile.component;

  const content =
    profile.name === 'private' ? (
      <PrivateGuard>
        <Routes />
      </PrivateGuard>
    ) : (
      <Routes />
    );

  return (
    <RouterProvider>
      <ProfileComp menu={profile.menu}>
        <Page>{content}</Page>
      </ProfileComp>
    </RouterProvider>
  );
};
